import { render, staticRenderFns } from "./StartupsBySourceChart.vue?vue&type=template&id=22c150ff&"
import script from "./StartupsBySourceChart.vue?vue&type=script&lang=js&"
export * from "./StartupsBySourceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports